import { FeatureLogger } from "../utils/feature-logger";

const name = "drift-analytics";

export const logger = new FeatureLogger(name);
